import { createAction } from '@reduxjs/toolkit'
import { CommentDiscipline, CommentWithReplies } from '../models/Comment'
import { ConstructionTab } from '../reducers/construction'

export const setComments = createAction<{
  tab: ConstructionTab
  comments: CommentWithReplies[]
}>('comments/setComments')
export const setCommentReplies = createAction<{
  tab: ConstructionTab
  commentId: number
  replies: CommentWithReplies[]
}>('comments/setCommentReplies')
export const addComment = createAction<{
  tab: ConstructionTab
  comment: CommentWithReplies
}>('comments/addComment')
export const addCommentReply = createAction<{
  tab: ConstructionTab
  commentId: number
  reply: CommentWithReplies
}>('comments/addCommentReply')
export const updateComment = createAction<{
  tab: ConstructionTab
  commentId: number
  newComment: CommentWithReplies
}>('comments/updateComment')
export const setIsCommentsMode = createAction<boolean>(
  'comments/setIsCommentsMode',
)
export const setIsAddCommentMode = createAction<boolean>(
  'comments/setIsAddCommentMode',
)
export const setCommentsTypeFilter = createAction<CommentDiscipline | null>(
  'comments/setCommentsTypeFilter',
)
export const updateAddCommentInfo = createAction<{
  commentDiscipline?: CommentDiscipline | null
  position?: { x: number; y: number }
}>('comments/updateAddCommentInfo')
export const resetCommentsState = createAction('comments/resetCommentsState')
export const deleteComment = createAction<{
  tab: ConstructionTab
  commentId: number
}>('comments/deleteComment')
